var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Bootstrap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 57,
    x2: 32,
    y2: 7,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 53,
    x2: 32,
    y2: 11,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,30.45v3.1c-2.77,0.31 -4.93,2.4 -5.95,5.67c-1.02,3.31 -1.16,7.37 -1.05,10.51c0.11,3.26 -2.43,6.27 -5.87,6.27h-34.26c-3.44,0 -5.98,-3.01 -5.87,-6.27c0.11,-3.14 -0.03,-7.2 -1.05,-10.51c-1.02,-3.27 -3.18,-5.36 -5.95,-5.67v-3.1c2.77,-0.31 4.93,-2.4 5.95,-5.67c1.02,-3.31 1.16,-7.37 1.05,-10.51c-0.11,-3.26 2.43,-6.27 5.87,-6.27h34.26c3.44,0 5.98,3.01 5.87,6.27c-0.11,3.14 0.03,7.2 1.05,10.51c1.02,3.27 3.18,5.36 5.95,5.67z",
    fill: "none",
    stroke: "url(#color-1)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,53c-0.95,0 -1.599,-0.465 -1.976,-0.854c-0.599,-0.619 -0.925,-1.462 -0.896,-2.314c0.11,-3.134 -0.005,-7.677 -1.181,-11.495c-0.875,-2.804 -2.466,-4.995 -4.514,-6.337c2.048,-1.341 3.639,-3.529 4.511,-6.326c1.18,-3.829 1.295,-8.372 1.185,-11.51c-0.028,-0.848 0.298,-1.691 0.896,-2.31c0.376,-0.389 1.025,-0.854 1.975,-0.854h34.26c0.95,0 1.599,0.465 1.976,0.854c0.599,0.619 0.925,1.462 0.896,2.314c-0.11,3.134 0.005,7.677 1.181,11.495c0.875,2.804 2.467,4.995 4.515,6.337c-2.048,1.341 -3.639,3.529 -4.511,6.326c-1.18,3.829 -1.295,8.372 -1.185,11.51c0.028,0.848 -0.298,1.691 -0.896,2.31c-0.377,0.389 -1.026,0.854 -1.976,0.854zM36.713,31.135c2.657,-0.428 4.744,-2.891 4.744,-5.65c0,-3.93 -3.105,-6.485 -7.829,-6.485h-10.628v25.99h10.689c5.66,0 9.07,-2.769 9.07,-7.35c0,-3.461 -2.433,-5.955 -6.047,-6.352v-0.153zM32.631,22.298c2.993,0 4.693,1.334 4.693,3.746c0,2.576 -1.975,4.011 -5.558,4.011h-4.766v-7.757zM27,41.692v-8.552h5.6c3.909,0 5.935,1.435 5.935,4.245c0,2.81 -1.975,4.306 -5.701,4.306h-5.834z",
    fill: "url(#color-2)",
    stroke: "none",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Bootstrap);
export default __webpack_public_path__ + "static/media/icons8-bootstrap.8376060a79ee8cde3e0d69169d16bf52.svg";
export { ForwardRef as ReactComponent };